import { Select } from 'antd'
import React from 'react'

import type { SelectProps as AntdSelectProps } from 'antd'


import { useState, useMemo } from 'react';
import { CssIcon } from '@/components/CssIcon';
interface SelectProps extends AntdSelectProps {}

export type { SelectProps }

type InternalSelect = typeof Select
interface CustomSelectInstance extends InternalSelect {
  displayName: string
  SECRET_COMBOBOX_MODE_DO_NOT_USE: typeof Select.SECRET_COMBOBOX_MODE_DO_NOT_USE
  OptGroup: typeof Select.OptGroup
  Option: typeof Select.Option
  _InternalPanelDoNotUseOrYouWillBeFired: typeof Select._InternalPanelDoNotUseOrYouWillBeFired
}

const CustomSelect = React.forwardRef(
  (props?: SelectProps, ref?: React.ComponentProps<typeof Select>['ref']) => {
    const { className, onOpenChange, ...rest } = props || {}
    const [open, setOpen] = useState(rest.defaultOpen)

    const showSearch = useMemo(() => {
      if (rest.showSearch !== undefined) {
        return rest.showSearch
      }

      return !!rest.mode
    }, [rest.mode, rest.showSearch])

    return (
      <Select
        ref={ref}
        className={className}
        onOpenChange={(open) => {
          setOpen(open)
          onOpenChange?.(open)
        }}
        suffixIcon={
          showSearch && open ? (
            <CssIcon className='i-com--search text-f-text-tertiary size-5' />
          ) : (
            <CssIcon className='i-com--down text-f-text-tertiary size-5' />
          )
        }
        {...rest}
      />
    )
  },
) as any as CustomSelectInstance

CustomSelect.displayName = 'CustomSelect'

CustomSelect.SECRET_COMBOBOX_MODE_DO_NOT_USE =
  Select.SECRET_COMBOBOX_MODE_DO_NOT_USE
CustomSelect.OptGroup = Select.OptGroup
CustomSelect.Option = Select.Option
CustomSelect._InternalPanelDoNotUseOrYouWillBeFired =
  Select._InternalPanelDoNotUseOrYouWillBeFired

export default CustomSelect
